<div class="container" fxLayout="column">
  <h3>{{ prefix }} {{ title }}</h3>
  <mat-form-field appearance="outline" floatLabel="always" fxFlex="100%">
    <input matInput type="text" [(ngModel)]="externalSystemId" aria-label="External System Id" />
  </mat-form-field>
  <div mat-dialog-actions fxLayoutGap="5px">
    <button mat-raised-button color="primary" (click)="buildResult()" [disabled]="!canSubmit()">{{ prefix }}</button>
    <button type="button" mat-button [mat-dialog-close]="buildNoAction()">Cancel</button>
  </div>
</div>
